import { useState, useEffect } from 'react';
import OkrService from '../services/okrs';

export const useFetchDirectReporteeObjectives = ({ 
  loadingDirectReportee, 
  directReporteeId,
  meetingId,
  isConversationTeamOkrSection,
  isConversationPersonalOkrSection,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [response, setResponse] = useState([null, null]);

  const handleFetchData = async () => {
    if (!directReporteeId) return;
    let err, data;
    if (isConversationTeamOkrSection || isConversationPersonalOkrSection) {
      [err, data] = await OkrService.getMeetingObjectives({ meetingId, attendeeId: directReporteeId });
    
    } else {
      [err, data] = await OkrService.getObjectivesByUserId({ userId: directReporteeId });
    }

    setResponse([err, data]);
    setIsLoading(false);
  };
    
  useEffect(() => {
    if(
      !loadingDirectReportee && 
      (isConversationTeamOkrSection || isConversationPersonalOkrSection)
    ) handleFetchData();
  },[loadingDirectReportee, directReporteeId]);

  return { loadingDirectReporteeObjectives: isLoading , response };
};
